module.exports = __webpack_public_path__ + "static/img/反面定位框选.2ebf946.gif";


//////////////////
// WEBPACK FOOTER
// ./src/v2/assets/images/反面定位框选.gif
// module id = xd9u
// module chunks = 129